/**
 * Utility functions for parsing search keywords
 * Matches the behavior of the old Angular application
 */

/**
 * Parses a search query string into an array of keywords
 * Splits on spaces and/or commas, handling consecutive delimiters
 * 
 * @param query - The search query string
 * @returns Array of trimmed keywords, empty array if no valid query
 * 
 * @example
 * parseKeywords("React, TypeScript, Mantine") // ["React", "TypeScript", "Mantine"]
 * parseKeywords("React TypeScript Mantine")   // ["React", "TypeScript", "Mantine"]
 * parseKeywords("React, TypeScript Mantine") // ["React", "TypeScript", "Mantine"]
 * parseKeywords("  React  ,  TypeScript  ") // ["React", "TypeScript"]
 * parseKeywords("")                          // []
 * parseKeywords("   ")                       // []
 */
export const parseKeywords = (query: string): string[] => {
  if (!query.trim()) return [];
  
  // Use the same regex as Angular: split on spaces and/or commas
  // [ ,]+ means: one or more spaces and/or commas
  return query.trim().split(/[ ,]+/).filter(word => word.length > 0);
};

/**
 * Alternative function name for backward compatibility
 * @deprecated Use parseKeywords instead
 */
export const splitKeywords = parseKeywords;
